import React from "react";
import {observer} from "mobx-react";

import "./time-series-tab-pane.scss";

import {Segment, Tab} from "semantic-ui-react";
import {isMobileOnly} from "react-device-detect";

import {Kiwis, TimeSeries} from "../../../../../kiwis";
import {Chart} from "./chart/chart";

import {ChartConfiguration} from "../../../../../config/chart-configuration";

interface TimeSeriesTabPaneProps {
    kiwis: Kiwis;
    chartConfig: ChartConfiguration;
    parentWidth: number;
    parentHeight: number;
    aspectRatio: number; // aspect ratio of parent windows
    timeSeries: TimeSeries;
    active: boolean; // if tab is active
}


@observer
export class TimeSeriesTabPane extends React.Component<TimeSeriesTabPaneProps, any> {
    constructor(props: TimeSeriesTabPaneProps) {
        super(props);
        this.state = {
            updating: false
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        // TODO remove watches
    }

    render() {
        const {timeSeries, active, kiwis, chartConfig, aspectRatio, parentWidth, parentHeight} = this.props;
        const className = `geo-chart-graph-segment
            ${chartConfig.rangeSelector.onlyPeriod ? "only-period" : ""}
            ${isMobileOnly ? "is-mobile-only" : ""}`;
        return (
            <Tab.Pane key={`pane-${timeSeries.id}`}
                className={"time-series-tab-pane"}
                active={active} >
                <Segment className={className}>
                    <Chart kiwis={kiwis}
                        config={chartConfig}
                        timeSeries={timeSeries}
                        visible={active}
                        aspectRatio={aspectRatio}
                        parentWidth={parentWidth}
                        parentHeight={parentHeight}
                    />
                </Segment>
            </Tab.Pane>
        );
    }
}
